import * as Styled from './styled';
import { Props } from './types';
import PrimaryButton from './sections/PrimaryButton';
import SecondaryButton from './sections/SecondaryButton';
import { FuelTypography } from '@frete.com/fuel-react';
import Grid from '~components/dumbs/Grid';

function Modal({
  open,
  onClose,
  title,
  buttons,
  message,
  width,
  children,
  highlightedMessage,
}: Props) {
  const [secondaryButton, primaryButton] = buttons;

  return (
    open && (
      <Styled.Background>
        <Styled.Modal $width={width}>
          <Grid container direction="column" spacing={3}>
            <Grid container>
              <Grid xs={11}>
                <FuelTypography size="heading-sm" variant="bold">
                  {title}
                </FuelTypography>
              </Grid>
              <Grid xs={1} align="center" container justify="center">
                {onClose && (
                  <Styled.Close onClick={onClose} aria-label="fechar modal" />
                )}
              </Grid>
            </Grid>
            <Grid>
              <FuelTypography size="body-sm" color="neutral-default">
                {message}
              </FuelTypography>
            </Grid>
            {highlightedMessage && (
              <Grid>
                <Styled.HighlightedMessage>
                  <FuelTypography
                    size="body-sm"
                    variant="bold"
                    color="neutral-default"
                  >
                    {highlightedMessage}
                  </FuelTypography>
                </Styled.HighlightedMessage>
              </Grid>
            )}
            {children && <Grid>{children}</Grid>}
            <Grid container align="center" justify="end">
              {secondaryButton && (
                <Grid>
                  <SecondaryButton
                    onClick={secondaryButton.onClick}
                    show={!!secondaryButton}
                  >
                    {secondaryButton.text}
                  </SecondaryButton>
                </Grid>
              )}
              {primaryButton && (
                <Grid>
                  <PrimaryButton
                    onClick={primaryButton.onClick}
                    loading={primaryButton.loading}
                    show={!!primaryButton}
                    type={primaryButton.type}
                  >
                    {primaryButton.text}
                  </PrimaryButton>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Styled.Modal>
      </Styled.Background>
    )
  );
}

Modal.defaultProps = {
  width: '378px',
};

export default Modal;
